
import React, { useEffect , useState } from "react";
import { Box, Typography, List, ListItem, ListItemText, Link } from "@mui/material";
import { progress } from "../input/progress_scores";
const postal = require('postal');

function InfoPanelBlank() {
  return (<div className="info-panel">
    <Box sx={{ padding: 2, height: "100%", overflowY: "auto" }}>
    {/* Key Points Section */}
    <Typography variant="h5" gutterBottom>
          Key Points
          </Typography>
    <Typography variant="subtitle1" color="textSecondary" gutterBottom>
    Click on a region for more info.
    </Typography>
    </Box>
    </div>)
}

function hasProgressMarker2P(feature: any) {

  const country_code = feature.properties.ISO_A3
  const country_progress = progress.get(country_code) as any

  if (!country_progress) return

  if (country_progress.type == "ProgressMarker2") {
    const areaName = feature.properties.ADMIN
    const keyPoints = country_progress.keyPoints
    const related = country_progress.related

    return {areaName, keyPoints, related}
  }

  console.log(country_progress)
  
  return false
}

function InfoPanel() {

  const [areaName, setAreaName] = useState()
  const [keyPoints, setKeyPoints] = useState([])
  const [relatedLinks, setRelatedLinks] = useState([])

  useEffect(() => {
    const sub = postal.subscribe({
      channel: "ui", topic: "updateInfoPanel",
      callback: (data: any) => {
        console.log("got update", data)
        if (data.feature) {
          let pm = hasProgressMarker2P(data.feature)

          if (!pm) return

          const {areaName, keyPoints, related} = pm
          setAreaName(areaName)
          setKeyPoints(keyPoints)
          setRelatedLinks(related)
        }
      }
    })

    return () => {
      sub.unsubscribe()
    }
  }, [])

  if (!areaName) {
    return <InfoPanelBlank />
  }

  return (
    <div className="info-panel">
      <Box sx={{ padding: 2, height: "100%", overflowY: "auto" }}>
        {/* Key Points Section */}
        <Typography variant="h5" gutterBottom>
          Key Points
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {areaName}
        </Typography>
        <List>
            <ListItem disablePadding>
              <ListItemText primary={`• ${keyPoints}`} />
            </ListItem>
        </List>

      </Box>
    </div>
  );
}
          // {keyPoints.map((point, index) => (
          // ))}

        // {/* Related Section */}
        // <Typography variant="h6" gutterBottom sx={{ marginTop: 3 }}>
        //   Related
        // </Typography>
        // <List>
        //   {relatedLinks.map((link, index) => (
        //     <ListItem key={index} disablePadding>
        //       <ListItemText
        //         primary={
        //           <Link href={link.url} target="_blank" rel="noopener noreferrer">
        //             {link.label}
        //           </Link>
        //         }
        //       />
        //     </ListItem>
        //   ))}
        // </List>

export { InfoPanel }